<ng-container *ngIf="state$ | async as state">
  <div [class.column--round]="!state.isSubCategorySelected"
       class="flyout2-column column-2"
       data-cy="navigation-flyout-column-2"
  >
    <ul class="structure">
      <li *ngFor="let category of navigation$ | async; index as i"
          [attr.aria-label]="category?.label"
          [attr.data-filtered]="(dataFiltered$ | async) ? '1' : '0'"
          [attr.data-target]="category?.label"
          [class.open]="(selectedCategory$ | async)?.id === category?.id"
          data-cy="navigation-flyout-column-2-item"
          role="menuitem"
      >
        <ul class="structure">
          <ng-container *ngIf="category?.label === products || category?.label === applications; else noFilters">
            <li *ngFor="let filter of category?.children; index as i"
                [attr.aria-label]="filter?.label"
                [class.open]="(activeFilter$ | async)?.label === filter?.label"
                data-cy="navigation-flyout-column-2-filter-item"
                role="menuitem"
            >
              <ul [class.selected-subcategory]="(activeSubCategory$ | async)"
                  class="nav"
                  data-cy="navigation-flyout-column-2-filter-list"
              >
                <li *ngFor="let subCategory of filter?.children; index as ind"
                    [class.active]="(activeSubCategory$ | async)?.label === subCategory?.label"
                    class="subcategory-list-item"
                    data-cy="navigation-flyout-column-2-filter-subcategory"
                >
                  <mb-link *ngIf="subCategory?.children?.length"
                           [dataColor]="category?.label === products ? subCategory.color || orange : orange"
                           [dataEventAction]="'Click ' + subCategory?.label"
                           [dataEventLabel]="category?.label"
                           [dataFilter]="category?.label + ' ' + (activeFilter$ | async)?.label"
                           [dataTarget]="category?.label + '_' + subCategory?.label?.toLocaleLowerCase()?.replaceAll(' ', '-')"
                           [linkData]="{ url: 'javascript:void(0)', uid: 'special', text: subCategory?.label }"
                           (click)="emitSubCategoryClickEvent($event, category, subCategory, filter)"
                           dataEventCategory="TopNavi"
                  ></mb-link>
                  <mb-link *ngIf="!subCategory?.children?.length"
                           [dataEventAction]="'Click ' + subCategory?.label"
                           [dataEventLabel]="category?.label"
                           [dataFilter]="category?.label + ' ' + (activeFilter$ | async )?.label"
                           [linkData]="{ url: subCategory?.url, uid: 'content_link', text: subCategory?.label }"
                           (clickEvent)="closeEvent.emit($event)"
                           styleClass="is-link"
                           dataEventCategory="TopNavi"
                  ></mb-link>
                </li>
              </ul>
            </li>
          </ng-container>
          <ng-template #noFilters>
            <li [attr.aria-label]="category?.label"
                [class.open]="!!(selectedCategory$ | async)"
                [id]="category?.label?.toLocaleLowerCase()"
                data-cy="navigation-flyout-column-2-filter-none-item"
                role="menuitem"
            >
              <ul class="nav">
                <li *ngFor="let subCategory of category?.children; index as i"
                    [class.active]="(selectedSubCategories$ | async)?.[category?.label]?.label === subCategory?.label"
                    [class.current]="!subCategory?.children?.length && isCurrentRoute(subCategory?.url)"
                    [ngClass]="{'external-url': subCategory.isExternalUrl && subCategory.children.length === 0}"
                    data-cy="navigation-flyout-column-2-filter-none-subcategory"
                    class="subcategory-list-item"
                >
                  <mb-link *ngIf="subCategory?.children?.length; else noChildren"
                           [dataColor]="category?.color || orange"
                           [dataEventAction]="'Click ' + subCategory?.label"
                           [dataEventLabel]="category?.label"
                           [dataTarget]="category?.label + '_' + subCategory?.label?.toLocaleLowerCase()?.replaceAll(' ', '-')"
                           [linkData]="{ url: 'javascript:void(0)', uid: 'special', text: subCategory?.label }"
                           (click)="emitSubCategoryClickEvent($event, category, subCategory)"
                           dataEventCategory="TopNavi"
                  ></mb-link>
                  <ng-template #noChildren>
                    <mb-link [dataColor]="category?.label === 'Products' ? subCategory.color || orange : orange"
                             [dataCy]="'navigation-flyout-column-2-link-' + subCategory?.label"
                             [dataEventAction]="'Click ' + subCategory?.label"
                             [dataEventLabel]="subCategory?.label"
                             [dataTarget]="category?.label + '_' + subCategory?.label?.toLocaleLowerCase()?.replaceAll(' ', '-')"
                             [id]="subCategory?.id"
                             [linkData]="{ url: subCategory?.url, uid: subCategory.isExternalUrl ? 'url' : 'content_link', text: subCategory?.label }"
                             (clickEvent)="closeEvent.emit($event)"
                             dataEventCategory="TopNavi"
                             styleClass="is-link"
                    ></mb-link>
                    <span *ngIf="subCategory.isExternalUrl">
                        <img src="/assets/icons/svg/external-link.svg" />
                    </span>
                  </ng-template>
                </li>
              </ul>
            </li>
          </ng-template>
        </ul>
      </li>
    </ul>
  </div>
</ng-container>
